import * as React from "react";
import { SVGProps } from "react";

const Inbox = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.801 4.228a1.75 1.75 0 0 1 1.613-1.07h11.174c.702 0 1.337.42 1.611 1.066l3.741 8.828a.75.75 0 0 1 .06.293v7.562a1.75 1.75 0 0 1-1.75 1.75H2.75A1.75 1.75 0 0 1 1 20.907v-7.5c0-.1.02-.199.059-.29L4.8 4.227Zm1.613.43a.25.25 0 0 0-.23.152L2.88 12.657H8a.75.75 0 0 1 .648.372l1.533 2.628h3.638l1.533-2.628a.75.75 0 0 1 .64-.372l5.13-.051-3.304-7.796a.25.25 0 0 0-.23-.153H6.414ZM21.5 14.101l-5.067.05-1.535 2.633a.75.75 0 0 1-.648.372h-4.5a.75.75 0 0 1-.648-.372L7.57 14.157H2.5v6.75c0 .138.112.25.25.25h18.5a.25.25 0 0 0 .25-.25v-6.805Z"
    />
  </svg>
);

export default Inbox;
